import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSunDust, faSnowflake, faSun } from "@fortawesome/pro-regular-svg-icons";

import { getFullTyreDescription, getTyrePosition, getTruckTyrePositon, getTyreSize } from "../../util";
import QuestionResultStatus from "../../../QuestionResultStatus";
import { TYRE_POSITION, SEASONS } from "../../../../../../util/tyre";
import LabelBadge from "../../../LabelImages/components/LabelBadge";
import { getImageLabel } from "../../../../util";

const formatPrice = price => {
  if (!price) return "0.00";
  return price.toLocaleString("de-DE", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
};

const renderTyreSeasonIcon = season => {
  switch (season) {
    case SEASONS.ALL_SEASON:
      return <FontAwesomeIcon icon={faSunDust} style={{ fontSize: "1.2em", color: "#21ba45" }} />;

    case SEASONS.WINTER:
      return <FontAwesomeIcon icon={faSnowflake} style={{ fontSize: "1.2em", color: "#2185d0" }} />;

    case SEASONS.SUMMER:
      return <FontAwesomeIcon icon={faSun} style={{ fontSize: "1.2em", color: "#fbbd08" }} />;

    default:
      return null;
  }
};

const TireQuestionItem = ({ question, hideTyrePositionLabels, settings, t }) => {
  const imageLabel = getImageLabel(question.images);

  return (
    <>
      <div className="tire-row">
        <div className="tire-row-data">
          <div className="tire-cell tire-position">
            {TYRE_POSITION.IS_TRUCK_TYRE(question.tyre_position) ? getTruckTyrePositon(question.tyre_position, t) : getTyrePosition(question, hideTyrePositionLabels, t)}
          </div>
          <div className="tire-cell">
            <strong>{t("cc_size").message || "Size"}:</strong> {renderTyreSeasonIcon(question?.tyre.season)} {getTyreSize(question.tyre)}
          </div>
          <div className="tire-cell">
            <strong>{t("cc_type").message || "Type"}:</strong> {getFullTyreDescription(question.tyre, settings.is_tyre_net_enabled)}
          </div>
          <div className="tire-cell">
            <strong>{t("cc_brand").message || "Brand"}:</strong> {question.tyre?.manufacturer}
          </div>
          {question.tyre_profile > 0 && (
            <div className="tire-cell">
              <strong>{t("cc_profile").message || "Profile"}:</strong> {`${question.tyre_profile} mm`}
            </div>
          )}

          {question.price > 0 && (
            <div className="tire-cell">
              <strong>{t("cc_price").message || "Price"}:</strong> {formatPrice(question.price)}
            </div>
          )}

          {question.raw && (
            <div className="tire-cell tire-remarks">
              <strong>{t("cc_remark").message || "Remark"}:</strong> {question.raw}
            </div>
          )}
        </div>

        <div className="tire-row-side">
          {imageLabel && (
            <span className="tire-row-badge">
              <LabelBadge label={imageLabel} />
            </span>
          )}

          <span className="tire-row-status">
            <QuestionResultStatus status={question.status} />
          </span>
        </div>
      </div>

      {question.tyre_replacements?.map((replacement, index) => (
        <div className="tire-row tire-replace" key={`${question.id || question.title || "replacement"}-${index}`}>
          <div className="tire-row-data tire-row-data--replace">
            <div className="tire-cell">
              <strong>{t("cc_replace_with").message || "Replace with"}:</strong>
            </div>
            <div className="tire-cell">
              <strong>{t("cc_size").message || "Size"}:</strong> {renderTyreSeasonIcon(replacement.tyre?.season)} {getTyreSize(replacement.tyre)}
            </div>
            <div className="tire-cell">
              <strong>{t("cc_type").message || "Type"}:</strong> {getFullTyreDescription(replacement.tyre, settings.is_tyre_net_enabled)}
            </div>
            <div className="tire-cell">
              <strong>{t("cc_brand").message || "Brand"}:</strong>
              {replacement.tyre.manufacturer}
            </div>
            {replacement.profile > 0 && (
              <div className="tire-cell">
                <strong>{t("cc_profile").message || "Profile"}:</strong> {`${replacement.profile} mm`}
              </div>
            )}
            {replacement.price > 0 && (
              <div className="tire-cell">
                <strong>{t("cc_price").message || "Price"}:</strong> {formatPrice(replacement.price)}
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default withTranslation()(TireQuestionItem);
